import request from '@/utils/request'

/**
 * @description 上传
 * @param {Object} param data {Object} 传值参数
 */
export function getOssConfig (configId) {
  return request({
    url: '/common/get-cos-signature',
    method: 'get'
  })
}


// export function getTenCosConfig (configId) {
//   return request({
//     url: '/common/get-vueOss-signature',
//     method: 'get'
//   }).then(function (res) {
//     return res.data;
//   })
// }

// 全局变量，用于存储CDN域名
let cdnDomainCache = null;

/**
 * TcVod 签名回调（视频上传默认带 procedure）
 */
export function getTenCosConfig() {
  return fetchVodSignature(true)
};

/**
 * 封面等图片上传：不带转码任务流，且不返回 CDN 域名（保持 vod-qcloud.com）
 */
export function getTenCosConfigForImage() {
  return fetchVodSignature(false)
};

function fetchVodSignature(includeProcedure) {
  return request({
    url: '/common/get-vueOss-signature',
    method: 'get',
    params: { procedure: includeProcedure }
  }).then(function (res) {
    if (typeof res.data === 'object' && res.data.signature) {
      cdnDomainCache = includeProcedure ? res.data.cdnDomain : null
      return res.data.signature
    }
    return res.data
  })
}

// 获取CDN域名
export function getCdnDomain() {
  return cdnDomainCache;
};
